export default __webpack_public_path__ + "static/TomWilford-60208bb4fecdf28767567aeb8365a0a1.jpg";